import { IconButton, InputBase, Paper } from "@material-ui/core";
import React, { Component } from "react";
import { Col, Row, Image } from "react-bootstrap";
import Media from "react-media";
import DeletePopup from "../../../reusableComponents/allPopupReusable/smallPopup/DeletePopup";
import { OrderStatus } from "./FilterComponentsReusable/OrderStatus";
// import { SetWaitTime } from "../../../reusableComponents/allPopupReusable/tableNumberPopup/SetWaitTime";
// import TableSizePopup from "../../../reusableComponents/allPopupReusable/tableNumberPopup/TableSizePopup";
import OrderFilterSection from "../../../vendorDashboardComponents/Orders/OrderDashboard/OrderFilterSection";
import SearchIcon from "@material-ui/icons/Search";
import OrderingBufferTime from "../../../vendorDashboardComponents/Orders/OrderRequest/OrderingBufferTime";
import { TopDateField } from "../../../vendorDashboardComponents/Orders/OrderDashboard/OrderDashboard";
import { Scan } from "../../../vendorDashboardComponents/seatingDashboard/seatingDashboard/Scan";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import VoiceSearchSeating from "../../../vendorDashboardComponents/seatingDashboard/seatingDashboard/VoiceSearchSeating";
import VoiceSearchSeatingMobile from "../../../vendorDashboardComponents/seatingDashboard/seatingDashboard/VoiceSearchSeatingMobile";
import OrderbufferTimeMobile from "../../../vendorDashboardComponents/Orders/OrderRequest/OrderbufferTimeMobile";
import {
  PENDING_ORDER_STATUS,
  ALL_ORDER_STATUS,
  TAKEAWAY_ORDER_STATUS,
  CURBSIDE_ORDER_STATUS,
  DINE_In_ORDER_STATUS,
  SKIP_THE_LINE_ORDER_STATUS,
  DELIVERY_ORDER_STATUS,
  HISTORY_ORDER_STATUS,
} from "../../../../enums/OrderEnums";

// Animations

import styled, { keyframes } from "styled-components";
import { zoomIn } from "react-animations";
import shadows from "@material-ui/core/styles/shadows";
import { DropDownButtonMobile } from "../../../reusableComponents/dropDownButtonReusable/DropDownButtonMobile";

const zoomAnimation = keyframes`${zoomIn}`;

const ZoomDiv = styled.div`
  animation: 1s ${zoomAnimation};
`;

// End Animations

const orderstatus = [
  { id: 10, title: "All", value: "All", clickAction: () => { } },
  {
    id: 0,
    title: "Order Request",
    value: "Order Request",
    clickAction: () => { },
  },
  {
    id: 1,
    title: "Order Accepted",
    value: "Order Accepted",
    clickAction: () => { },
  },
  {
    id: 2,
    title: "Getting Prepared",
    value: "Getting Prepared",
    clickAction: () => { },
  },
  { id: 3, title: "Ready", value: "Ready", clickAction: () => { } },
  { id: 5, title: "On Hold", value: "On Hold", clickAction: () => { } },
  // { id: 6, title: "Rejected", value: "Rejected", clickAction: () => {} },
  { id: 7, title: "Completed", value: "Completed", clickAction: () => { } },
  { id: 8, title: "Cancelled", value: "Cancelled", clickAction: () => { } },
];

const processTime = [
  { id: 8, title: "All", value: "All", clickActionProcessingTime: () => { } },
  {
    id: 0,
    title: "00 - 00 Mins",
    value: 0,
    clickActionProcessingTime: () => { },
  },
  {
    id: 1,
    title: "00 - 05 Mins",
    value: 5,
    clickActionProcessingTime: () => { },
  },
  {
    id: 2,
    title: "05 - 10 Mins",
    value: 10,
    clickActionProcessingTime: () => { },
  },
  {
    id: 3,
    title: "10 - 15 Mins",
    value: 15,
    clickActionProcessingTime: () => { },
  },
  {
    id: 4,
    title: "15 - 20 Mins",
    value: 20,
    clickActionProcessingTime: () => { },
  },
  {
    id: 5,
    title: "20 - 25 Mins",
    value: 25,
    clickActionProcessingTime: () => { },
  },
  {
    id: 6,
    title: "25 - 30 Mins",
    value: 30,
    clickActionProcessingTime: () => { },
  },
  { id: 7, title: "Custom", value: "", clickActionProcessingTime: () => { } },
];

class FiltersSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderstatus: 10,
      showStatus: "All",
      orderProcessingTime: 8,
      orderProcessingStauts: "All",
      displayGrid: false,
      search: "",
      selectedDate: "",
      openScan: false,
      markAllCompleteRecord: 0,
      showSearch: false,
    };
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    let dinerData = nextProps.allOrderData;
    for (let i = 0; i < dinerData.length; i++) {
      if (dinerData[i].length <= 0) {
        return {
          markAllCompleteRecord: 0,
        };
      } else if (dinerData[i].order_status !== 6) {
        return {
          markAllCompleteRecord: 1,
        };
      } else {
        return {
          markAllCompleteRecord: 2,
        };
      }
    }
  }

  onSearchChange = (e) => {
    if (
      e.target.value === "all" ||
      e.target.value === "remove" ||
      e.target.value === "clear"
    ) {
      this.setState({
        search: "",
      });
    } else if (this.state.search !== e.target.value) {
      this.setState({
        search: e.target.value,
      });
    } else {
      this.setState({
        search: "",
      });
    }
    this.props.onSearchParent(e.target.value);
  };

  onVoiceSearchChange = (data) => {
    if (data === "all" || data === "remove" || data === "clear") {
      this.setState({
        search: "",
      });
    } else if (this.state.search !== data) {
      this.setState({
        search: data,
      });
    } else {
      this.setState({
        search: "",
      });
    }
    this.props.onSearchParent(data);
  };

  onNextHoursOpen = (e) => {
    this.setState({
      displayDropDown: !this.state.displayDropDown,
    });
  };

  onChangeDate = (date) => {
    // setSelectedDate(date);
    this.setState({
      selectedDate: date,
    });
  };

  /****************************************
   * @DESC Ope Modal
   ***************************************/
  onOpenModal = (id) => {
    this.setState({ open: id });
  };
  onCloseModal = () => {
    this.setState({ open: 0 });
  };
  onOpenModalPax = () => {
    this.setState({ openPax: true });
  };
  onCloseModalPax = () => {
    this.setState({ openPax: false });
  };

  /****************************************
   * @DESC Big Button Show Status Handler
   ***************************************/
  bigButtonShowStatusHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      showStatusText: type,
    });
  };
  selectStatusClick = (e) => {
    this.setState({
      showStatus:
        this.state.showStatusText === "" ? "All" : this.state.showStatusText,
      open: false,
    });
  };

  bigButtonShowPaxHandler = (e, type) => {
    e.preventDefault();
    this.setState({
      showPaxText: type,
    });
  };
  selectPaxClick = (e) => {
    console.log("hi");
    this.setState({
      showPax: this.state.showPaxText === "" ? "All" : this.state.showPaxText,
      openPax: false,
    });
  };

  searchButton = (e) => {
    e.preventDefault();
    this.setState({
      displaySearch: true,
    });
  };

  searchButtonClose = (e) => {
    e.preventDefault();
    this.setState({ displaySearch: false });
  };

  searchButtonMobile = (e) => {
    e.preventDefault();
    this.setState({
      displayMobileSearch: true,
    });
  };

  searchButtonMobileClose = (e) => {
    e.preventDefault();
    this.setState({
      displayMobileSearch: false,
    });
  };

  onChangePagination = (page) => {
    this.setState({
      currentPagination: page,
    });
  };

  clickAction = (data) => {
    this.setState({
      orderstatus: data.id,
      showStatus: data.title,
    });
    this.props.onChangeOrderStatus(data.id, data.orderType);
    this.onCloseModal(0);
  };

  clickActionProcessingTime = (data) => {
    console.log(data);
    this.setState({
      orderProcessingTime: data.id,
      orderProcessingStauts: data.title,
    });
    this.props.onChangeOrderProcessing(data);
    this.onCloseModal(0);
  };

  openModalScan = () => {
    this.setState({ openScan: true });
  };
  closeModalScan = () => {
    this.setState({ openScan: false });
  };

  onSuccessScan = (data) => {
    if (this.props?.onSuccessScan) {
      this.props.onSuccessScan({ scanData: data, scanComplete: true });
    }
  };

  render() {
    const { displayGrid, openScan } = this.state;
    return (
      <React.Fragment>
        <Row>
          <div
            className="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2 seating-topbar-search mobile-pb-0"
            style={{ alignItems: "center" }}
          >
            <Media query="(min-width:992px)">
              <div className="filter-button w-50">
                <OrderFilterSection
                  orderTypeData={(data) => this.props.orderType(data)}
                  paymentTypeData={(data) => this.props.paymentType(data)}
                  paymentStatusData={(data) => this.props.paymentStatus(data)}
                />
              </div>
            </Media>


            <Media query="(min-width: 991px)">
              <div
                className="filter-button-search w-100 p-0"
                style={{ cursor: "pointer" }}
              >
                <Image
                  onClick={() =>
                    this.setState({ showSearch: !this.state.showSearch })
                  }
                  alt="filter"
                  title="filter"
                  width="80px"
                  src={require("../../../../assets/images/iconButton/newsearchicon.svg")}
                />
              </div>
            </Media>            
            <Media query="(max-width: 992px)">

              {/* <Scan
                openModalScan={this.openModalScan}
                onCloseModal={this.closeModalScan}
                open={openScan}
                sendData={this.props.onboarding}
                onSuccessScan={this.onSuccessScan}
              />  */}


              {/* <div className="filter-button-qrcode">
                <div className="filter-button-qrcode-box">
                  <img
                    src={require("../../../../assets/images/ActionImages/image/qrcode.svg")}
                    className="img-fluid"
                    alt="QR Scan"
                    title="QR Scan"
                  />
                </div>
              </div>  */}
            </Media>
          </div>

          <Media query="(max-width: 991px)">
            <div className="searchFilterSection d-flex w-100" style={{backgroundColor:"#FFFFFF",  padding: '8px 16px'}}>
              <div className="filter-button w-20  ">
                <OrderFilterSection
                  orderTypeData={(data) => this.props.orderType(data)}
                  paymentTypeData={(data) => this.props.paymentType(data)}
                  paymentStatusData={(data) => this.props.paymentStatus(data)}
                />
              </div>
              <div className="w-100 ml-3">
                <VoiceSearchSeatingMobile
                  onSearchChange={this.onSearchChange}
                  onVoiceSearchChange={(data) => this.onVoiceSearchChange(data)}
                  search={this.state.search}
                />
              </div>
            </div>

          </Media>

          <Media query="(min-width: 991px)">
            <div className="col-12 col-sm-12 col-md-2 col-lg-2 col-xl-2"></div>
          </Media>
          <Media query="(min-width: 991px)">
            <div
              className="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 vendor-orders-request"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div className="row w-100">
                {this.props.pathname === "/orderdashboard/11" ? (
                  <React.Fragment>
                    <div className="col-4 col-sm-4 col-md-4 col-lg-4"></div>
                  </React.Fragment>
                ) : (
                  <div
                    className="col-4 col-sm-4 col-md-4 col-lg-4"
                    style={{ borderRight: "1px solid #e0e0e0"}}
                  >
                    <div className="buttonType"
                   >
                    <OrderStatus
                      // datatomap={orderstatus}
                      datatomap={
                        this.props.pathname === "/orderdashboard/0"
                          ? TAKEAWAY_ORDER_STATUS
                          : this.props.pathname === "/orderdashboard/1"
                            ? CURBSIDE_ORDER_STATUS
                            : this.props.pathname === "/orderdashboard/2"
                              ? SKIP_THE_LINE_ORDER_STATUS
                              : this.props.pathname === "/orderdashboard/3"
                                ? DINE_In_ORDER_STATUS
                                : this.props.pathname === "/orderdashboard/7"
                                  ? DELIVERY_ORDER_STATUS
                                  : this.props.pathname === "/orderdashboard/10"
                                    ? ALL_ORDER_STATUS
                                    : this.props.pathname === "/orderdashboard/20"
                                      ? HISTORY_ORDER_STATUS
                                      : PENDING_ORDER_STATUS
                      }
                      title="Order Status"
                      subtitle="Select one relevant option from below"
                      status={this.state.showStatus}
                      seatingStatus={this.state.orderstatus}
                      onOpenModal={() => {
                        this.onOpenModal(1);
                      }}
                      onCloseModal={() => {
                        this.onCloseModal(0);
                      }}
                      open={this.state.open === 1}
                      clickAction={(data) => this.clickAction(data)}
                      pathnameData={this.props.pathname}
                    />
                    </div>
                  </div>
                )}
               
                <div
                  className="col-4 col-sm-5 col-md-4 col-lg-4"
                  style={{ borderRight: "1px solid #e0e0e0" }}
                >
                  <OrderingBufferTime />

                </div>
               
                <div className="col-4 col-sm-3 col-md-4 col-lg-4">
                  <OrderStatus
                    datatomap={processTime}
                    title="Processing Time"
                    subtitle="Select one relevant option from below"
                    status={this.state.orderProcessingStauts}
                    seatingStatus={this.state.orderProcessingTime}
                    // onClickSeated={(e) => {
                    //   this.setState({ processTime: e });
                    // }}
                    onOpenModal={() => {
                      this.onOpenModal(8);
                    }}
                    onCloseModal={() => {
                      this.onCloseModal(0);
                    }}
                    open={this.state.open === 8}
                    clickAction={(data) => this.clickActionProcessingTime(data)}
                  />
                </div>
              </div>
            </div>
          </Media>
          <Media query="(max-width: 992px)">
            <hr className="m-0 mb-3" />
          </Media>
          <Media query="(max-width: 992px)">
            <div
              className="col-12 col-sm-12 col-md-7 col-lg-7 col-xl-7 vendor-orders-request"
              style={{ display: "flex", alignItems: "center" }}
            >
              <div className="row w-100">
                {this.props.pathname === "/orderdashboard/11" ? (
                  <React.Fragment>
                    <div className="col-4 col-sm-4 col-md-4 col-lg-4"></div>
                  </React.Fragment>
                ) : (
                  <div
                    className="col-4 col-sm-4 col-md-4 col-lg-4  f14-500"
                    style={{ borderRight: "1px solid #e0e0e0", minHeight:"36px"}}
                  >
                    <OrderbufferTimeMobile/>
                   
                  </div>
                )}
                <div
                  className="col-4 col-sm-5 col-md-4 col-lg-4 f14-500"
                  style={{ borderRight: "1px solid #e0e0e0", minHeight:"36px" }}
                >
                  
                  <OrderStatus
                      // datatomap={orderstatus}
                      datatomap={
                        this.props.pathname === "/orderdashboard/0"
                          ? TAKEAWAY_ORDER_STATUS
                          : this.props.pathname === "/orderdashboard/1"
                            ? CURBSIDE_ORDER_STATUS
                            : this.props.pathname === "/orderdashboard/2"
                              ? SKIP_THE_LINE_ORDER_STATUS
                              : this.props.pathname === "/orderdashboard/3"
                                ? DINE_In_ORDER_STATUS
                                : this.props.pathname === "/orderdashboard/7"
                                  ? DELIVERY_ORDER_STATUS
                                  : this.props.pathname === "/orderdashboard/10"
                                    ? ALL_ORDER_STATUS
                                    : this.props.pathname === "/orderdashboard/20"
                                      ? HISTORY_ORDER_STATUS
                                      : PENDING_ORDER_STATUS
                      }
                      
                      title="Order Status"
                      subtitle="Select one relevant option from below"
                      status={this.state.showStatus}
                      seatingStatus={this.state.orderstatus}
                      onOpenModal={() => {
                        this.onOpenModal(1);
                      }}
                      onCloseModal={() => {
                        this.onCloseModal(0);
                      }}
                      open={this.state.open === 1}
                      clickAction={(data) => this.clickAction(data)}
                      pathnameData={this.props.pathname}
                      orderStatus
                    />

                </div>
                <div className="col-4 col-sm-3 col-md-4 col-lg-4 f14-500 ">

                  <OrderStatus
                    datatomap={processTime}
                   
                    title="Processing Time"
                    subtitle="Select one relevant option from below"
                    status={this.state.orderProcessingStauts}
                    seatingStatus={this.state.orderProcessingTime}
                    // onClickSeated={(e) => {
                    //   this.setState({ processTime: e });
                    // }}
                    onOpenModal={() => {
                      this.onOpenModal(8);
                    }}
                    onCloseModal={() => {
                      this.onCloseModal(0);
                    }}
                    open={this.state.open === 8}
                    clickAction={(data) => this.clickActionProcessingTime(data)}
                  />
                </div>
              </div>
            </div>
          </Media>
          <Media query="(max-width: 992px)">
            <hr className="m-0 mb-3" />
          </Media>
          <div
            className="col-12 col-sm-12 col-md-1 col-lg-1 col-xl-1 d-flex justify-content-end p-0"

          >
            <div className="row w-100 justify-content-center">
              {/* <Media query="(max-width: 991px)">
                <div className="col-8 col-sm-8 col-md-6 col-lg-6 col-xl-6">
                  <div className="complete_record_image">
                    {this.props.mobileDateFilter}
                  </div>
                </div> 
              </Media> */}
              <div className="col-4 col-sm-4 col-md-12 col-lg-12 col-xl-12 p-0">
                <Media query="(max-width: 991px)">
                  <div
                    className="btn-group mobile-align-s w-100"
                    
                    role="group"
                    aria-label="Basic example"
                  >
                    <button
                      type="button"
                      className={
                        displayGrid
                          ? "btn grid-button-group p-1"
                          : "btn grid-button-group p-1 grid-button-group-active"
                      }
                      onClick={this.onGridViewOpen}
                    >
                      <img
                        src={require("../../../../assets/images/ActionImages/image/grid.svg")}
                        className="img-fluid" 
                        alt="table"
                        title="table"
                      />
                    </button>
                    <button
                      type="button"
                      className={
                        displayGrid
                          ? "btn grid-button-group p-1 grid-button-group-active"
                          : "btn grid-button-group p-1"
                      }
                      onClick={this.onGridViewOpen}
                    >
                      <img
                        src={require("../../../../assets/images/superadmin/ordericon/chef.svg")}
                        className="img-fluid"
                        style={{minHeight:"40px"}}
                        alt="table"
                        title="table"
                      />
                    </button>
                    <button
                      type="button"
                      className={
                        displayGrid
                          ? "btn grid-button-group p-1 grid-button-group-active"
                          : "btn grid-button-group p-1"
                      }
                      onClick={this.onGridViewOpen}
                    >
                      <img
                        src={require("../../../../assets/images/superadmin/ordericon/delivery man icon.svg")}
                        className="img-fluid"
                        style={{minHeight:"40px"}}
                        alt="table"
                        title="table"
                      />
                    </button>
                  </div>
                </Media>
                <Media query="(min-width: 992px)">
                  <div
                    className="btn-group mobile-align-right"
                    role="group"
                    aria-label="Basic example"
                  >
                    <button
                      type="button"
                      className={
                        displayGrid
                          ? "btn grid-button-group grid-button-group-active"
                          : "btn grid-button-group"
                      }
                      onClick={this.onGridViewOpen}
                    >
                      <img
                        src={require("../../../../assets/images/ActionImages/image/grid.svg")}
                        className="img-fluid"
                        alt="table"
                        title="table"
                      />
                    </button>
                    <button
                      type="button"
                      className={
                        displayGrid
                          ? "btn grid-button-group"
                          : "btn grid-button-group grid-button-group-active"
                      }
                      onClick={this.onGridViewOpen}
                    >
                      <img
                        src={require("../../../../assets/images/superadmin/ordericon/chef.svg")}
                        className="img-fluid"
                        alt="table"
                        title="table"
                      />
                    </button>
                    <button
                      type="button"
                      className={
                        displayGrid
                          ? "btn grid-button-group"
                          : "btn grid-button-group grid-button-group-active"
                      }
                      onClick={this.onGridViewOpen}
                    >
                      <img
                        src={require("../../../../assets/images/superadmin/ordericon/delivery man icon.svg")}
                        className="img-fluid"
                        alt="table"
                        title="table"
                      />
                    </button>
                  </div>
                </Media>
              </div>
            </div>
          </div>
          {/* <div className="col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 right-side-seating">
            {this.props.orderStatus === 0 ? null : (
              <Media query="(max-width: 991px)">
                <div className="complete_record_image">
                  {this.props.orderTypeTwo !== 11 && (
                    <>
                      {this.state.markAllCompleteRecord === 0 ||
                      this.state.markAllCompleteRecord === 1 ? (
                        <Image
                          fluid
                          src={require("../../../../assets/images/AuthImages/checked.png")}
                          alt="Checked"
                          title="All Record"
                          className="checked-images"
                        />
                      ) : (
                        <DeletePopup
                          actionBy="order"
                          display={true}
                          displayPopup="completedRecord"
                          buttonDisplay="completedRecord"
                          buttonText="Complete Record"
                          bigText="Are you sure to complete all ordering records ?"
                          getMarkAll={() => this.props.getMarkAll()}
                        />
                      )}
                      <p className="complete_record_small_text f10-500">
                        {this.state.markAllCompleteRecord === 0 ? (
                          "No Records Found"
                        ) : this.state.markAllCompleteRecord === 1 ? (
                          <>
                            No completed <br />
                            order found
                          </>
                        ) : (
                          <>
                            Mark all orders
                            <br /> as complete
                          </>
                        )}
                      </p>
                    </>
                  )}
                </div>
              </Media>
            )}
          </div> */}
        </Row>
        {this.state.showSearch && (
          <div className="mb-3">
            <ZoomDiv>
              <>
                <br />
                <VoiceSearchSeating
                  onSearchChange={this.onSearchChange}
                  onVoiceSearchChange={(data) => this.onVoiceSearchChange(data)}
                  search={this.state.search}
                />
              </>
            </ZoomDiv>
          </div>
        )}

        <div align="right ">
          {this.props.orderStatus === 0 ? (
            ""
          ) : (
            <Media query="(min-width: 992px)">
              <div className="complete_record_image d-flex align-items-center justify-content-end">
                {this.props.orderTypeTwo !== 11 ? (
                  <>
                    {this.state.markAllCompleteRecord === 0 ||
                      this.state.markAllCompleteRecord === 1 ? (
                      <Image
                        fluid
                        src={require("../../../../assets/images/AuthImages/checked.png")}
                        alt="Checked"
                        title="All Record"
                        className="checked-images mr-3"
                        style={{ maxWidth: "25px" }}
                      />
                    ) : (
                      <DeletePopup
                        actionBy="order"
                        display={true}
                        displayPopup="completedRecord"
                        buttonDisplay="completedRecord"
                        buttonText="Complete Record"
                        bigText="Are you sure to complete all ordering records ?"
                        getMarkAll={() => this.props.getMarkAll()}
                      />
                    )}
                    <p className="complete_record_small_text f10-500">
                      {this.state.markAllCompleteRecord === 0 ? (
                        "No Records Found"
                      ) : this.state.markAllCompleteRecord === 1 ? (
                        <>
                          No completed
                          <br /> order found
                        </>
                      ) : (
                        <>
                          Mark all orders
                          <br /> as complete
                        </>
                      )}
                    </p>
                  </>
                ) : (
                  <div style={{ width: "150px" }}></div>
                )}
              </div>
            </Media>
          )}
        </div>
      </React.Fragment>
    );
  }
}

FiltersSection.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  allOrderData: PropTypes.array.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  allOrderData: state.vendorOrdering.vendor_get_all_takeaway_order,
});

export default connect(mapStateToProps, null)(withRouter(FiltersSection));
